
import { PERMISSION_VIP_TYPE, DUBA_VIP_TYPE } from '@/config/dataMap'
import common from '@/client/modules/common'

const getPermissionVipInfoItem = (state, vipType) => {
  if (!state.user.permissionVipInfo || !vipType) {
    return null
  }
  return state.user.permissionVipInfo.find(item => +item.vip_type === vipType)
}

function hasVipPermission (state) {
  if (state.user.permissionVipInfo && state.user.permissionVipInfo.length > 0) {
     const index = state.user.permissionVipInfo.findIndex(item => item.vip_type != 1 )
     return index !== -1
  } else {
    return false
  }
}

export default {
  userInfo: state => state.user.userInfo,

  // 用户权限剩余次数
  permissionInfo: state => state.user.permissionInfo,

  pdfPermissionVipInfo: state => {
    return getPermissionVipInfoItem(state, PERMISSION_VIP_TYPE.member)
  },

  loginStatus: state => state.user.loginStatus && state.user.userInfo,

  token: state => state.user.token,

  continuousInfo: state => state.user.continuousInfo,

  isVip: state => {
    return hasVipPermission(state)
  },

  isMember: state =>
    (state.user.loginStatus && state.user.userInfo
      ? state.user.userInfo.vip_type && +state.user.userInfo.vip_type !== DUBA_VIP_TYPE.nonmember
      : false),

  /** 视频会员 */
  isVideoVip: state => {
    const info = getPermissionVipInfoItem(state, PERMISSION_VIP_TYPE.videoVip)
    return state.user.loginStatus && state.user.userInfo && +info?.vip_type === PERMISSION_VIP_TYPE.videoVip && info?.vip_ex_date > state.user.userInfo.current_time
  },

  /** 视频终身会员 */
  isVideoLifeMember: state => {
    const info = getPermissionVipInfoItem(state, PERMISSION_VIP_TYPE.videoLifeMember)
    return state.user.loginStatus && state.user.userInfo && +info?.vip_type === PERMISSION_VIP_TYPE.videoLifeMember && info?.vip_ex_date > state.user.userInfo.current_time
  },

  isPdfMember: state => {
    const pdfVipInfo = getPermissionVipInfoItem(state, PERMISSION_VIP_TYPE.member)
    return state.user.loginStatus && state.user.userInfo && pdfVipInfo
      ? pdfVipInfo.vip_type && +pdfVipInfo.vip_type === PERMISSION_VIP_TYPE.member && pdfVipInfo.vip_ex_date > state.user.userInfo.current_time
      : false
  },
  // pdf 终身会员
  isPdfLifeMember: state => {
    const info = getPermissionVipInfoItem(state, PERMISSION_VIP_TYPE.lifeMember)
    return state.user.loginStatus && state.user.userInfo && info
      ? info.vip_type && +info.vip_type === PERMISSION_VIP_TYPE.lifeMember
      : false
  },

  // 普通会员
  normalMember: state => {
    const { loginStatus, userInfo: { vip_type } = {} } = state.user
    return loginStatus && Number(vip_type) === DUBA_VIP_TYPE.normalMember
  },
  // 超级会员
  isSuperMember: state => {
    const { loginStatus, userInfo: { vip_type } = {} } = state.user || {}
    return loginStatus && Number(vip_type) === DUBA_VIP_TYPE.superMember
  },
  // 钻石会员
  isDiamondMember: state => {
    const { loginStatus, userInfo: { vip_type } = {} } = state.user || {}
    return loginStatus && Number(vip_type) === DUBA_VIP_TYPE.diamondMember
  },

  // 是否包时段(连续续费)会员
  isContinuous: state => {
    const { loginStatus, userInfo } = state.user || {}
    return loginStatus && userInfo && Number(userInfo.is_continuous) === 1
  },
  // VIP剩余天数
  excessDays: state =>
    state.user.userInfo &&
      (state.user.userInfo.vip_ex_date - state.user.userInfo.current_time) / 86400,

  // export const isTourist = state => state.userInfo && state.userInfo.is_tourist
  isTourist: state => state.user.userInfo && state.user.userInfo.is_tourist,

  openId: state =>
    (state.user.userInfo ? state.user.userInfo.open_id || '' : ''),

  privilege: state => state.user.privilege || null,

  oldMember: state => state.user.oldMember || {},

  avatar: state => {
    return (
      state.user.userInfo &&
        state.user.userInfo.avatar &&
        state.user.userInfo.avatar.replace(/^(http:)/, '')
    )
  },

  /** 获取客户端安装时间 */
  getClientInstallTime: (state) => {
    const errorNum = 1000001
    return common.API.client_install_time().then(e => {
      const current_time = state.user.userInfo?.current_time || 0
      const install_time = e?.ProductInstallTime || 0

      if (!current_time || !install_time) {
        return {
          install_time_sec: errorNum,
          install_days: errorNum
        }
      }

      const day = (current_time - install_time) / (24 * 60 * 60)
      return {
        install_time_sec: +install_time, // 安装时间
        install_days: Math.round(day) // 安装天数
      }
    }).catch(() => {
      return {
        install_time_sec: errorNum,
        install_days: errorNum
      }
    })
  }
}
